import { createBrowserHistory, History } from "history";

const history: History = createBrowserHistory();

if (window.Cypress) {
  window.browserHistory = history;
}

export { history };
